import React, { Component, Fragment } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { connect } from 'react-redux'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import axios from "axios";

const LostSchema = Yup.object().shape({
    lostemail: Yup.string()
      .email("Invalid email")
      .required("Required")
  });

class LostForm extends Component {
    render() {
      return (
        <Formik
        initialValues={{ lostemail: '' }}
        validationSchema={LostSchema}
        onSubmit={(values, { setSubmitting }) => {
              axios
                .post("auth/lost", {
                  lostemail: values.lostemail
                })
                .then(res => {
                  if(res.data.success){
                    toast.success(res.data.success);
                  }
                  setSubmitting(false);
                }).catch(error => {  toast.error(error.message);setSubmitting(false); });
        }}
      >
        {({ isSubmitting }) => (
          <Fragment>
          <div style={{ marginTop: 20}}>{ this.props.termes.mailpassword.mailparamTextLost}</div>
          <Form>
            <label htmlFor="email">{ this.props.termes.mailpassword.mailparamLabelEmail}</label>
            <Field type="email" name="lostemail" />
            <ErrorMessage name="lostemail"  className="error" component="div" />
            <button type="submit" className="outlined" disabled={isSubmitting}>
            { this.props.termes.mailpassword.mailparamBTNLost}
            </button>
          </Form>
          </Fragment>
        )}
      </Formik>

      );
    }
}

const mapStateToProps = (state)=>{
  return {
    termes: state.settings.termes
  }
};


export default connect(mapStateToProps)(LostForm);